import React from "react"
import Container from "../Container"
import logo_1 from "../../images/home/clients/logo_1.svg"
import logo_2 from "../../images/home/clients/logo_2.svg"
import logo_3 from "../../images/home/clients/logo_3.svg"
import logo_4 from "../../images/home/clients/logo_4.svg"
import logo_5 from "../../images/home/clients/logo_5.svg"
import logo_6 from "../../images/home/clients/logo_6.svg"
import logo_7 from "../../images/home/clients/logo_7.svg"

function Clients() {
  return (
    <Container>
      <div className="mb-[268px]">
        <p className="text-[40px]  text-center mb-[81px]  font-[700] leading-[42px]">
          TRUSTED CLIENTS
        </p>
        <div className="flex  flex-wrap justify-center gap-10">
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_1} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_2} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className=" w-[80%]" src={logo_3} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_4} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_5} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_6} alt="" />
          </div>
          <div className="flex items-center justify-center  aspect-[267/129] rounded-[10px] w-1/3 lg:w-1/5 border">
            <img className="" src={logo_7} alt="" />
          </div>
        </div>
      </div>
    </Container>
  )
}

export default Clients
